import classNames from 'classnames';
import { useState } from 'react';

export interface TabOption<K extends string> {
    _id: K;
    label: string;
}
interface MissionHubTabsProps<K extends string> {
    tabs: TabOption<K>[];
    onTabSelect: (id: K) => void;
    children?: React.ReactNode;
    actionEl?: React.ReactNode;
}
export const MissionHubTabs = <K extends string>(props: MissionHubTabsProps<K>) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const handleTabSelection = (index: number) => {
        setActiveTabIndex(index);
        props.onTabSelect(props.tabs[index]._id);
    };
    return (
        <div>
            <div className="flex items-center border-b-4 border-[#4d3964]/10 ">
                {props.tabs.map((t, i) => (
                    <button
                        key={i}
                        aria-label={t.label}
                        className={classNames('t__button--u2 p-4 box-content border-b-4 -mb-1', {
                            'border-pink-60': i === activeTabIndex,
                            'border-transparent': i !== activeTabIndex,
                        })}
                        onClick={() => handleTabSelection(i)}
                    >
                        {t.label}
                    </button>
                ))}
                <div className="ml-auto">{props.actionEl}</div>
            </div>
            {props.children}
        </div>
    );
};
